import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/enterprise';
import { filters } from 'filters/enterprise';
import { listNavigator } from 'sagas/common';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Enterprise', actions, selectors, filters } );
}
